import {Component, Inject, OnInit} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {STREAM_TYPES} from '../player.component';
import {FormsModule} from '@angular/forms';


@Component({
  selector: 'app-player-select-type',
  templateUrl: './player-select-type.component.html',
  styleUrls: ['./player-select-type.component.scss'],
  imports: [
    FormsModule
]
})
export class PlayerSelectTypeComponent implements OnInit {
  protected readonly STREAM_TYPES = STREAM_TYPES;
  selectedStreamType: any;
  streamTypeHLS: boolean;
  streamTypeDASH: boolean;

  constructor(protected dialogRef: DialogRef<Number>,
              @Inject(DIALOG_DATA) data: {
                selectedStreamType: string,
                streamTypeHLS: boolean,
                streamTypeDASH: boolean
              }) {
    this.selectedStreamType = data.selectedStreamType;
    this.streamTypeHLS = data.streamTypeHLS
    this.streamTypeDASH = data.streamTypeDASH
  }

  ngOnInit(): void {
  }


}
